<template>
    <div class="error-page">
        <div class="error-desc">
            <div>你目前还没有授权访问的KCC站点。请联系你的项目经理（默认为KCC站点管理员）将你添加至KCC站点,之后相关KCC站点将出现在你的<span @click="openDashboard" class="link-pointer">KCC Dashboard</span>中，点击站点名字即可一键登录。建议你的项目经理观看此<span @click="open" class="link-pointer">短视频</span>，了解如何授权添加更多团队成员访问KCC站点。</div>
            <div>You are not as of yet authorised to access a KCC site. Please approach your engagement manager (who by default is the KCC engagement Site Administrator) to add you in the KCC engagement site. The KCC engagement site will then appear in your <span @click="openDashboard" class="link-pointer">KCC dashboard</span> and you can then login. Show your engagement manager this <span @click="open" class="link-pointer"> short video</span>,about how to grant KCC access to engagement team members. </div>

        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import windowConfig from "@/utils/windowConfig";

    export default {
        computed: {
            ...mapGetters('common', {
                getUser: 'getUser'
            }),
        },
        methods: {
            openDashboard(){
                sessionStorage.removeItem('JSESSIONID');
                localStorage.removeItem('JSESSIONID')
                sessionStorage.removeItem('siteClassification');
                sessionStorage.setItem('redirectUrl', JSON.stringify({name: 'home'}));
                this.$router.replace({name: 'home'});
            },
            open(){
                window.open(windowConfig.helpURL.howToConfigureKCCSite, '_blank');
            }
        }
    };
</script>


<style scoped>
    .error-page {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding-top: 20px;
        background: #f3f3f3;
        box-sizing: border-box;
    }
    .error-code span {
        color: #a172a9;
    }
    .error-desc {
        margin-left: 100px;
        margin-right: 100px;
        font-size: 18px;
        color: rgba(24, 151, 231, 1);
    }
    .error-desc div{
        white-space: pre-wrap;
    }

    .link-pointer{
        text-decoration: underline;
        color: rgb(65, 138, 179);
        font-weight: bolder;
        cursor: pointer;
    }
</style>
